module.exports = __webpack_public_path__ + "img/kinder2.bd833534.jpg";